import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
  EUnion,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutFooterLight = {
  factory: EElement({
    id: '81f4879e-1c4d-08db-a551-0c8aaf222edb',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('0fe02587-b46d-96fc-19f9-a66cb3d793bd')]),
      children: EList([
        EElement({
          id: '81f4879e-1c4d-08db-a551-0c8aaf222edc',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'ee6d6674-1e9c-eb0a-17f6-c5b917d3ff6a',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('fc56edf8-11c6-44e8-5581-789941fcb917'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'db33a6da-37f3-c496-6f92-e949cdfe33b0',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Link')
                      ),
                      data: ERecord({
                        button: EBoolean(false),
                        block: EText('inline'),
                        eventIds: EList([]),
                        link: ELiteral({
                          name: qualify(
                            Plugins.name('Basic'),
                            typeName('Link')
                          ),
                          value: JSON.parse('{"mode":"external","url":"#"}'),
                        }),
                        styleBlockIds: EList([
                          EText('53b66045-edd4-1887-44fa-4a01827a4b31'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'db33a6da-37f3-c496-6f92-e949cdfe33b1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.companyLogoPlaceholder),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272de970d684b5fd0f99038"}'
                                ),
                              }),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'fab2207d-0208-ac51-04f4-3367b8542cb7',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('c262024f-3aef-7a2e-f609-ef01cbba4362'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'fab2207d-0208-ac51-04f4-3367b8542cb8',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ab0cd1-da85-c0fc-60f3-5510588e9c2d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fab2207d-0208-ac51-04f4-3367b8542cb9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Company'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'fab2207d-0208-ac51-04f4-3367b8542cba',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('0c67f603-5dd1-3b2f-55e6-82bce1cd272e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fab2207d-0208-ac51-04f4-3367b8542cbb',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('How it works'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'fab2207d-0208-ac51-04f4-3367b8542cbc',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('0c67f603-5dd1-3b2f-55e6-82bce1cd272e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fab2207d-0208-ac51-04f4-3367b8542cbd',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Pricing'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'fab2207d-0208-ac51-04f4-3367b8542cbe',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('0c67f603-5dd1-3b2f-55e6-82bce1cd272e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fab2207d-0208-ac51-04f4-3367b8542cbf',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Docs'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e3764707',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('c262024f-3aef-7a2e-f609-ef01cbba4362'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e3764708',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ab0cd1-da85-c0fc-60f3-5510588e9c2d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e3764709',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Quick Link'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e376470a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('0c67f603-5dd1-3b2f-55e6-82bce1cd272e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e376470b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Pricing'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e376470c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('0c67f603-5dd1-3b2f-55e6-82bce1cd272e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a253b8b3-dd0d-e2ae-d2a9-88a1e376470d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Resources'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '910ffb43-ba72-1864-f585-84203372983d',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormWrapper')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('wrapper'),
                        }),
                        styleBlockIds: EList([
                          EText('f063b338-5f5a-f940-0042-b8d2e527d339'),
                        ]),
                        children: EList([
                          EElement({
                            id: '910ffb43-ba72-1864-f585-84203372983e',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormForm')
                            ),
                            data: ERecord({
                              form: ERecord({
                                type: EText('form'),
                                name: EText('Footer Form'),
                              }),
                              Source: EUnion({
                                tag: 'Default form',
                                value: ERecord({}),
                              }),
                              attr: ERecord({
                                id: EText('wf-form-Footer-Form'),
                                name: EText('wf-form-Footer-Form'),
                                'data-name': EText('Footer Form'),
                                redirect: EText(''),
                                'data-redirect': EText(''),
                                'data-wf-close-modal': EBoolean(false),
                                action: EText(''),
                                method: EEnum('get'),
                              }),
                              styleBlockIds: EList([
                                EText('d91c2a88-e986-9ee7-5ac0-ec03b3b7bb93'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8c21993a-7e66-1eff-1006-a399f55a0a31',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        '10ab0cd1-da85-c0fc-60f3-5510588e9c2d'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '8c21993a-7e66-1eff-1006-a399f55a0a32',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Subscribe'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '2b1dfb0f-f7ae-7c4b-eb1e-7d19e5a0ef3d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '68ed1aed-ff79-8b01-b35a-9252c1611979'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '910ffb43-ba72-1864-f585-842033729844',
                                        type: qualify(
                                          Plugins.name('Form'),
                                          Component.name('FormTextInput')
                                        ),
                                        data: ERecord({
                                          form: ERecord({
                                            name: EText('Footer Email'),
                                            type: EText('input'),
                                            passwordPage: EBoolean(false),
                                          }),
                                          attr: ERecord({
                                            autofocus: EBoolean(false),
                                            maxlength: ENumber(256),
                                            name: EText('Footer-Email'),
                                            'data-name': EText('Footer Email'),
                                            placeholder: EText(
                                              'Get product updates'
                                            ),
                                            type: EEnum('email'),
                                            id: EText('Footer-Email'),
                                            disabled: EBoolean(false),
                                            required: EBoolean(true),
                                          }),
                                          xattr: EList([
                                            ERecord({
                                              name: EText('aria-label'),
                                              value: EText(
                                                'Get product updates'
                                              ),
                                            }),
                                          ]),
                                          styleBlockIds: EList([
                                            EText(
                                              'a855b76e-2f93-e53b-4a85-245602b4eb15'
                                            ),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '910ffb43-ba72-1864-f585-842033729845',
                                        type: qualify(
                                          Plugins.name('Form'),
                                          Component.name('FormButton')
                                        ),
                                        data: ERecord({
                                          form: ERecord({
                                            type: EText('button'),
                                          }),
                                          attr: ERecord({
                                            type: EText('submit'),
                                            value: EText(''),
                                            'data-wait':
                                              EText('Please wait...'),
                                          }),
                                          eventIds: EList([]),
                                          styleBlockIds: EList([
                                            EText(
                                              '49d71ce2-bdfa-4dac-d947-c39bc301c103'
                                            ),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                              temp: ERecord({
                                state: EEnum('normal'),
                                'password-state': EEnum('normal'),
                              }),
                            }),
                          }),
                          EElement({
                            id: '910ffb43-ba72-1864-f585-842033729846',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormSuccessMessage')
                            ),
                            data: ERecord({
                              form: ERecord({
                                type: EText('msg-done'),
                              }),
                              children: EList([
                                EElement({
                                  id: '910ffb43-ba72-1864-f585-842033729847',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(true),
                                    children: EList([
                                      EElement({
                                        id: '910ffb43-ba72-1864-f585-842033729848',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Thank you! Your submission has been received!'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '910ffb43-ba72-1864-f585-842033729849',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormErrorMessage')
                            ),
                            data: ERecord({
                              form: ERecord({
                                type: EText('msg-fail'),
                              }),
                              children: EList([
                                EElement({
                                  id: '910ffb43-ba72-1864-f585-84203372984a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(true),
                                    children: EList([
                                      EElement({
                                        id: '910ffb43-ba72-1864-f585-84203372984b',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Oops! Something went wrong while submitting the form.'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'f80309ce-53f2-6693-f5c8-da95c67fd13a',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('6934137b-bebc-0dd3-0127-8f081fe5e2a7'),
                  ]),
                  children: EList([]),
                }),
              }),
              EElement({
                id: '91c94821-5a37-d09c-8100-dd83f25702f6',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('3c0046e4-da26-68a7-1563-fdfb0e7f591a'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'e1937d9d-4951-2f4d-5ed3-892fbbfdd6d3',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        text: EBoolean(true),
                        tag: EEnum('div'),
                        styleBlockIds: EList([
                          EText('87784941-a689-2c8a-7a6b-6974d93b0b2f'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'e1937d9d-4951-2f4d-5ed3-892fbbfdd6d4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              '\xA9 2022 Company name. All rights reserved'
                            ),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'd9dd7636-8fce-ab29-9565-d2692afdb324',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('5c7c781f-f836-2c57-439f-6b407d876257'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd9dd7636-8fce-ab29-9565-d2692afdb325',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('7543ee55-a53c-7b23-437f-8e3d319742b8'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd7636-8fce-ab29-9565-d2692afdb326',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.linkedinLogoCircleDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272de970d684b5fd0f99030"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd7636-8fce-ab29-9565-d2692afdb327',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('7543ee55-a53c-7b23-437f-8e3d319742b8'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd7636-8fce-ab29-9565-d2692afdb328',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.facebookLogoCircleDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272de970d684b5fd0f99027"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd7636-8fce-ab29-9565-d2692afdb329',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('7543ee55-a53c-7b23-437f-8e3d319742b8'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd7636-8fce-ab29-9565-d2692afdb32a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.twitterLogoCircleDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272de970d684b5fd0f99032"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '0fe02587-b46d-96fc-19f9-a66cb3d793bd',
      type: 'class',
      name: 'Footer Light',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 40px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {styleLess: 'padding-right: 15px; padding-left: 15px;'},
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'fc56edf8-11c6-44e8-5581-789941fcb917',
      type: 'class',
      name: 'Footer Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: flex-start;',
      children: [],
      variants: {
        medium: {styleLess: 'flex-wrap: wrap;'},
        tiny: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '53b66045-edd4-1887-44fa-4a01827a4b31',
      type: 'class',
      name: 'Footer Brand',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: 'c262024f-3aef-7a2e-f609-ef01cbba4362',
      type: 'class',
      name: 'Footer Block Two',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {tiny: {styleLess: 'margin-top: 40px;'}},
    },
    {
      _id: '10ab0cd1-da85-c0fc-60f3-5510588e9c2d',
      type: 'class',
      name: 'Footer Title',
      comb: '',
      styleLess: 'font-size: 18px; line-height: 32px; font-weight: 500;',
      children: [],
      variants: {},
    },
    {
      _id: '0c67f603-5dd1-3b2f-55e6-82bce1cd272e',
      type: 'class',
      name: 'Footer Link Two',
      comb: '',
      styleLess: 'margin-top: 20px; color: #1a1b1f; text-decoration: none;',
      children: [],
      variants: {main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'}},
    },
    {
      _id: 'f063b338-5f5a-f940-0042-b8d2e527d339',
      type: 'class',
      name: 'Footer Form',
      comb: '',
      styleLess: 'width: 315px; max-width: 100%; margin-bottom: 0px;',
      children: [],
      variants: {medium: {styleLess: 'width: 100%; margin-top: 40px;'}},
    },
    {
      _id: 'd91c2a88-e986-9ee7-5ac0-ec03b3b7bb93',
      type: 'class',
      name: 'Footer Form Container',
      comb: '',
      styleLess: '',
      children: [],
      variants: {medium: {styleLess: 'max-width: 350px;'}},
    },
    {
      _id: '68ed1aed-ff79-8b01-b35a-9252c1611979',
      type: 'class',
      name: 'Footer Form Block',
      comb: '',
      styleLess:
        'display: flex; margin-top: 24px; justify-content: center; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'a855b76e-2f93-e53b-4a85-245602b4eb15',
      type: 'class',
      name: 'Footer Form Field',
      comb: '',
      styleLess:
        'height: 48px; margin-bottom: 0px; padding-top: 12px; padding-right: 16px; padding-bottom: 12px; padding-left: 16px; border-top-style: solid; border-top-width: 1px; border-top-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); border-right-style: solid; border-right-width: 1px; border-right-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); border-left-style: solid; border-left-width: 1px; border-left-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); border-top-left-radius: 4px; border-bottom-left-radius: 4px; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; font-size: 14px; line-height: 22px;',
      children: [],
      variants: {
        main_placeholder: {
          styleLess:
            'color: hsla(228, 8.77%, 11.18%, 0.80); font-size: 14px; line-height: 22px;',
        },
        main_hover: {
          styleLess:
            'border-top-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-right-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-bottom-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-left-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00);',
        },
        main_focus: {
          styleLess:
            'border-top-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-right-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-bottom-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-left-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00);',
        },
      },
    },
    {
      _id: '49d71ce2-bdfa-4dac-d947-c39bc301c103',
      type: 'class',
      name: 'Footer Form Submit',
      comb: '',
      styleLess: `width: 50px; height: 48px; border-top-right-radius: 4px; border-bottom-right-radius: 4px; background-color: #1a1b1f; background-image: url(${images.rightArrowLight}); background-position: 50% 50%; background-size: auto; background-repeat: no-repeat; transition-property: all; transition-duration: 200ms; transition-timing-function: ease;`,
      children: [],
      variants: {
        main_hover: {
          styleLess:
            'background-color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
        },
      },
    },
    {
      _id: '6934137b-bebc-0dd3-0127-8f081fe5e2a7',
      type: 'class',
      name: 'Footer Divider Two',
      comb: '',
      styleLess:
        'width: 100%; height: 1px; margin-top: 40px; margin-bottom: 40px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '3c0046e4-da26-68a7-1563-fdfb0e7f591a',
      type: 'class',
      name: 'Footer Bottom',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        tiny: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
        small: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '87784941-a689-2c8a-7a6b-6974d93b0b2f',
      type: 'class',
      name: 'Footer Copyright',
      comb: '',
      styleLess: 'color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
      children: [],
      variants: {small: {styleLess: 'font-size: 14px; line-height: 20px;'}},
    },
    {
      _id: '5c7c781f-f836-2c57-439f-6b407d876257',
      type: 'class',
      name: 'Footer Social Block Two',
      comb: '',
      styleLess:
        'display: flex; margin-top: 0px; margin-left: -12px; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {
        tiny: {styleLess: 'margin-top: 20px;'},
        small: {styleLess: 'margin-top: 20px;'},
      },
    },
    {
      _id: '7543ee55-a53c-7b23-437f-8e3d319742b8',
      type: 'class',
      name: 'Footer Social Link',
      comb: '',
      styleLess: 'margin-left: 12px;',
      children: [],
      variants: {small: {styleLess: 'margin-left: 20px;'}},
    },
  ],
} as const;
